import React, { ForwardedRef } from 'react';

import { Placement } from '@floating-ui/core';
import cx from 'classnames';

import { usePopperArrowStyle } from '~shared/components/Popper/usePopperArrowStyle';

interface Props {
  placement: Placement;
  arrowY: number;
  arrowX: number;
  theme: 'light' | 'dark';
}
export const PopperArrow = React.forwardRef(function PopperArrow(
  { arrowX, arrowY, placement, theme }: Props,
  resolvedRef: ForwardedRef<HTMLDivElement>
) {
  const arrowStyle = usePopperArrowStyle({
    placement,
    arrowY,
    arrowX,
  });

  const styleClass = cx(
    theme === 'light' ? 'bg-white' : 'bg-black-95',
    'absolute m-0 p-0'
  );

  return <div className={styleClass} ref={resolvedRef} style={arrowStyle} />;
});
